const formatPercentage = (num:any) => {
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export default formatPercentage;
